import type { SVGProps } from 'react';
const SvgMeatballs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="bi bi-three-dots"
    viewBox="0 0 16 16"
    {...props}
  >
    <desc>{'Three Dots Streamline Icon: https://streamlinehq.com'}</desc>
    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
  </svg>
);
export default SvgMeatballs;
